export const development = {
  API: {
    baseURL: "http://127.0.0.1:5000/api"
    // baseURL: "http://ec2-52-15-170-206.us-east-2.compute.amazonaws.com/api"
    // baseURL: "http://efc3-188-163-84-84.ngrok.io/api"
  }
};
